module.exports = __webpack_public_path__ + "img/uptime.eea5481.svg";